<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t("message.add") }} {{ $tc("message.facture", 1) }}
          </h3>
        </div>
      </div>

      <div class="" :class="[ mobileView ? 'pt-3': 'card-body']">
        <b-form>
          <div class="" :class="[ mobileView ? '': 'container']">
            <p class="heading text-center">{{ $t("message.infoGenerale") }}</p>

            <b-row>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="etablissement-group"
                  :label="$t('message.nomEtablissement')"
                  label-for="etablissement"
                >
                  <select
                    id="etablissement"
                    v-model="$v.form.etablissement_id.$model"
                    @change="clearErrorField('etablissement_id')"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in mInstitutions"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback
                    v-if="$v.form.etablissement_id.$error"
                  >
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                  <span
                    v-if="errorshasField('categorie_id')"
                    style="color: red"
                  >
                    {{ getErrorsField("categorie_id") }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="nomPatient-group"
                  :label="$t('message.nomPatient')"
                  label-for="nomPatient"
                >
                  <select
                    id="nomPatient"
                    v-model="$v.form.dossier_medical_id.$model"
                    @change="getMedicalAdvicesPatient($event)"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in mPatients"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback
                    v-if="$v.form.dossier_medical_id.$error"
                  >
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                  <span
                    v-if="errorshasField('dossier_medical_id')"
                    style="color: red"
                  >
                    {{ getErrorsField("dossier_medical_id") }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="prestation2-group"
                  :label="$t('message.nomPrestation')"
                  label-for="prestation2"
                >
                  <select
                    id="prestation2"
                    v-model="$v.prestation.$model"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in prestations"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.objet }}
                    </option>
                  </select>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="association-group"
                  label="Association"
                  label-for="association"
                >
                  <select
                    id="association"
                    v-model="$v.form.association_id.$model"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in mAssociations"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.association_id.$error">
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('association_id')" style="color: red">
                    {{ getErrorsField("association_id") }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="dateFacturation-group"
                  :label="$t('message.dateFacturation')"
                  label-for="dateFacturation"
                >
                  <b-form-input
                    id="dateFacturation"
                    v-model="$v.form.date_facturation.$model"
                    :state="
                      $v.form.date_facturation.$dirty
                        ? !(
                            errorshasField('date_facturation') ||
                            $v.form.date_facturation.$error
                          )
                        : null
                    "
                    placeholder=""
                    type="date"
                    @focus="clearErrorField('date_facturation')"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    v-if="errorshasField('date_facturation')"
                  >
                    {{ getErrorsField("date_facturation") }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback
                    v-if="$v.form.date_facturation.$error"
                  >
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="selectMontant-group"
                  :label="$t('message.selectMontant')"
                  label-for="selectMontant"
                >
                  <select
                    id="selectMontant"
                    v-model="total"
                    @change="addToList()"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in selectMontant"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.montant }}
                    </option>
                  </select>
                </b-form-group>
              </b-col>
            </b-row>
            <div v-if="form.prestations.length > 0" class="my-2">
            <b-row>
                <b-col sm="2">Avis</b-col>
                <b-col sm="2">Medecin</b-col>
                <b-col sm="2">Association (20%)</b-col> 
                <b-col sm="2">Medecin avis (45%)</b-col> 
                <b-col sm="2">Medicasure (35%)</b-col>
                <b-col sm="2">Action</b-col> 
            </b-row>

                <template v-for="field in form.prestations" >
                <b-row  class="my-2" :key="field.id">
                    
                    <b-col sm="2">
                        {{field.name}}
                    </b-col> 
                    <b-col sm="2">
                        {{field.medecin_name}}
                    </b-col> 
                    <b-col sm="2">
                    <b-form-input
                        id="montantAssociation"
                        type="number"
                        :readonly="field.update === false"
                        :value="field.montant_association"
                        v-model="field.montant_association"
                    ></b-form-input>
                    </b-col>
                    <b-col sm="2">
                    <b-form-input
                        id="montantMedecin"
                        type="number"
                        :readonly="field.update === false"
                        :value="field.montant_medecin"
                        v-model="field.montant_medecin"
                    ></b-form-input>
                    </b-col>
                    <b-col sm="2">
                    <b-form-input
                        id="montantMedicasure"
                        type="number"
                        :readonly="field.update === false"
                        :value="field.montant_medicasure"
                        v-model="field.montant_medicasure"
                    ></b-form-input>
                    </b-col>
                    <b-col sm="2">
                    <b-button class="btn-sm" @click="field.update = true" variant="success">
                         <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button class="btn-sm" @click="retirerPrestation(field.id)" variant="danger">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    </b-col>
                </b-row>
                </template>
            </div>
            <hr/>
            <b-row class="justify-content-sm-center">
              <p> Montant total : {{ getMontantTotal() }} FCFA</p>
            </b-row>
            <hr/>
            <b-row class="justify-content-sm-center">
              <b-button
                @click="onSubmit"
                variant="primary"
                :disabled="form.prestations.length == 0"
              >
                {{ $t("message.enregistrerFacture") }}
              </b-button>
            </b-row>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require("jquery");
import { mapGetters } from "vuex";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import SlimSelect from "slim-select";
import moment from "moment";
import AppConfig from "../../constants/AppConfig";
export default {
  name: "Add",
  computed: {
    ...mapGetters([
      "hasAdminRole",
      "Associations",
      "userInstitutions",
      "errors",
      "patientAdvices",
      "hasGestionnaireRole",
      "hasMedecinControleRole",
      "isComptable",
      "hasAssistante"
    ]),

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.isComptable ||
        this.hasAssistante
      );
    },
    mAssociations: function () {
      let pArray = [];
      //
      _.forEach(
        _.orderBy(this.Associations, ["created_at"], ["desc"]),
        function (association) {
          let p = {};

          if (!_.isNull(association)) {
            p.region = association.region.toUpperCase();
            p.email = association.email;
            p.telephone = association.telephone;
            p.slug = association.slug;
            p.responsable = association.responsable;
            p.ville = association.ville;
            p.nom = association.nom + " (" + association.ville + ")";
            p.id = association.id;
            p.localisation = association.localisation;
          }
          pArray.push(p);
        }
      );


      return _.sortBy(pArray, ["nom"]);
    },
    mPrestations: function () {
      let pArray = [];
      return pArray;
    },

    mPatients: function () {
      let pArray = [];
      if (_.isNull(this.form.etablissement_id)) {
        return [];
      } else {
        let self = this;
        let etablissement = _.find(
          self.userInstitutions,
          function (institution) {
            return institution.id == self.form.etablissement_id;
          }
        );

        let patients = etablissement.patients;
        pArray = [];
        _.forEach(patients, function (patient) {
          if(!_.isNull(patient.user)){
            let id = patient.dossier.id;
            // let nom = patient.user.nom + " " + (!_.isNull(patient.user.prenom) ? "" : patient.user.prenom);
            let nom = patient.user.nom + ' ' + (_.isNull(patient.user.prenom) ? '' :patient.user.prenom);
            if (
              _.isUndefined(
                _.find(pArray, function (p) {
                  return p.id == id;
                }))) {
                pArray.push({ nom: nom, id: id });
            }
           }
        });
        return pArray;
      }
    },

    mInstitutions: function () {
      let iArray = [];
      _.forEach(this.userInstitutions, function (institution) {
        iArray.push({ nom: institution.name, id: institution.id });
      });
      return iArray;
    },
  },

  data() {
    return {
      mobileView: true,
      seen: false,
      prestations: [],
      continuer: false,
      prestationSelect: Object,
      selectMontant:[
        {
          id:15000,
          montant:15000
        },
        {
          id:10000,
          montant:10000
        }
      ],
      prestation: null,
      total: 0,
      form: {
        prestation: [],
        prestations: [],
        association_id: null,
        dossier_medical_id: null,
        etablissement_id: null,
        date_facturation: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  validations() {
    return {
      form: {
        prestation: { required },
        dossier_medical_id: { required },
        etablissement_id: { required },
        montant_association: { required },
        montant_medicasure: { required },
        montant_medecin: { required },
        date_facturation: { required },
        association_id: { required },
      },
      prestation: {
        montant_prestation: {},
        prestation_id: { required },
        association_id: { required },
      },
    };
  },
  watch:{

  },
  methods: {
     handleView() {
                this.mobileView = window.innerWidth <= 990;
    },
    getMontantTotal(){
          let total = 0 ;
          let sefl = this;
          _.forEach(sefl.form.prestations,function(item){
            total += parseInt(item.montant_association)+parseInt(item.montant_medicasure)+parseInt(item.montant_medecin);
          })
          return total;
    },
    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };
      this.$store.dispatch("getUserInstitutions", { args: args });
    },
    setMontant(event){
      let sefl = this;
       let array = [];
      array = sefl.form.prestations.map(items => {
          let item = {...items,
            montant_association : event.target.value * 0.2 ,
            montant_medicasure : event.target.value * 0.33 ,
            montant_medecin : event.target.value * 0.4 
           }; 
           
          return item;
      });
    },
    getMedicalAdvicesPatient(event) {
      let sefl = this;
      sefl.prestations = [];
      fetch(AppConfig.apiUrl + "/avis/patient/" + event.target.value, {
        method: "GET",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ms-token"),
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          _.forEach(result.avis, function (item) {
            sefl.prestations.push(item);
          });
        })
        .catch(function (error) {
         // console.error("Error:", error);
        });
    },

    validerForm(evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.continuer = true;
      }
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.$touch();

      // if(!this.$v.$invalid) {
      let args = {
        dossier_medical_id: this.form.dossier_medical_id,
        etablissement_id: this.form.etablissement_id,
        association_id: this.form.association_id,
        avis_id: this.prestation,
        avis: this.form.prestations,
      };

      let successMessage = this.$i18n.t("message.factureCreated");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      this.$store.dispatch("createFactureAvis", {
        args,
        errorMessages,
        successMessage,
      });
      // }
    },
    addToList() {
      // const isAlreadyExist = this.form.prestation.findIndex(i => i.id === $event.target.value);
      let sefl = this;
      sefl.form.prestations= [];
      let arrays = [];
      //if (isAlreadyExist === -1) {
      let _avis = this.getPrestation(sefl.prestation);
       
      _.forEach(_avis.medecin_avis, function (item) {
        let item2 = {
          name: item.avis,
          montant_prestation: sefl.total,
          montant_association : sefl.total * 0.2 ,
          montant_medicasure : sefl.total * 0.35 ,
          montant_medecin : sefl.total * 0.45,
          id: item.id,
          update : false,
          medecin_avis_id: item.medecin_id,
          medecin_name:item.medecin.nom+ " "+item.medecin.prenom,
          reduction: 0,
        };

        arrays.push(item2);
       
      });
     sefl.form.prestations= arrays;
    },

    getPrestation(id) {
      return _.find(this.prestations, function (prestation) {
        return prestation.id == id;
      });
    },
    retirerPrestation(id) {

      this.form.prestations = this.form.prestations.filter(
        (item) => item.id != id
      );
      this.form.prestation = this.form.prestation.filter(
        (item) => item != id
      );
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", { field });

      this.getErrorsField(field);
    },
    getAssociations() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getAssociations", { args: args });
    },
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {
    this.getUserInstitutions();

    this.getAssociations();

    var prestation = new SlimSelect({
      select: "#prestation2",
      placeholder: "Select prestation",
    });

    new SlimSelect({
      select: "#etablissement",
      placeholder: "Select etablissement",
      limit: 1,
    });

    new SlimSelect({
      select: "#nomPatient",
      placeholder: "Select patient",
      limit: 1,
    });
    new SlimSelect({
      select: "#association",
      placeholder: "Select association",
      limit: 1,
    });
    new SlimSelect({
      select: "#selectMontant",
      placeholder: "Select montant",
      limit: 1,
    });
    this.prestationSelect = prestation;
  },
};
</script>

<style scoped>
@import "~slim-select/dist/slimselect.min.css";
.truncate {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
